import { getFormValues, isInvalid } from 'redux-form';

export const getInvalid = (state) => isInvalid('partnerContactInfo')(state);
export const getValues = (state) => getFormValues('partnerContactInfo')(state);
